// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'
/* 主要方法 */
// import href from './assets/js/href'
/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

// 复制文本插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
// 富文本样式
import './assets/css/quill.snow.css'
import './assets/css/style.css'
/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

/* 回到顶部 */
import CustomerService from './components/Customer'
Vue.component(CustomerService.name,CustomerService)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


// main.js 或者其他的 Vue 插件配置文件
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  // 设置懒加载时的占位图
  loading: 'path/to/loading-image.gif',
  // 设置图片加载失败时的占位图
  error: 'path/to/error-image.png'
})


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js